import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../about/AboutPage.css'
import './PrivacyPolicyPage.css'
import quokkaImg from '../images/quokka.png'

const SUPPORT_EMAIL = 'info@quokka.kg'
const UPDATED_AT = '1 ноября 2026'
const OWNER = 'ИП Келдибеков Омурзак Келдибекович'
const ADDRESS = 'Кыргызская Республика, г. Бишкек, Свердловский р-н, ж/м Бакай-Ата, ул. Сыргак 15'
const PHONES = [
  { display: '0550 909 505', href: 'tel:+996550909505' },
  { display: '0506 905 509', href: 'tel:+996506905509' },
]

function TermsAndPaymentPage() {
  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow
    const prevBodyOverflow = document.body.style.overflow
    const root = document.getElementById('root')
    const prevRootOverflow = root?.style.overflow
    const prevRootHeight = root?.style.height
    const prevRootMinHeight = root?.style.minHeight

    document.documentElement.style.overflow = 'auto'
    document.body.style.overflow = 'visible'
    if (root) {
      root.style.overflow = 'visible'
      root.style.height = 'auto'
      root.style.minHeight = '100vh'
    }

    window.scrollTo(0, 0)

    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow
      document.body.style.overflow = prevBodyOverflow
      if (root) {
        root.style.overflow = prevRootOverflow || ''
        root.style.height = prevRootHeight || ''
        root.style.minHeight = prevRootMinHeight || ''
      }
    }
  }, [])

  return (
    <div className="ql qp">
      <header className="ql-nav">
        <div className="ql-nav-inner">
          <Link className="ql-brand" to="/" aria-label="Quokka">
            <img src={quokkaImg} alt="" className="ql-brand-mark" />
            <span>Quokka</span>
          </Link>
        </div>
      </header>

      <main className="qp-main">
        <article className="qp-article">
          <p className="qp-kicker">Юридическая информация</p>
          <h1>Условия оплаты, доставки, аренды и возврата</h1>
          <p className="qp-meta">Дата последнего обновления: {UPDATED_AT}</p>

          <p>
            Настоящий документ (далее — «Условия») определяет правила оформления заказов на покупку
            и аренду (прокат) товаров, проведения оплаты, доставки и возврата имущества, а также
            порядок отмены заказа и возврата денежных средств при использовании цифрового сервиса{' '}
            <strong>Quokka</strong> (далее — «Сервис») в соответствии с Гражданским кодексом
            Кыргызской Республики (включая нормы о розничной купле-продаже и об имущественном найме
            / прокате) и Законом Кыргызской Республики «О защите прав потребителей».
          </p>

          <section>
            <h2>Юридическая информация об операторе Сервиса</h2>
            <p>
              Владелец Сервиса: <strong>{OWNER}</strong>
            </p>
            <p>
              Адрес: <strong>{ADDRESS}</strong>
            </p>
            <p>
              Телефон:{' '}
              {PHONES.map((phone, index) => (
                <span key={phone.href}>
                  {index > 0 ? ', ' : null}
                  <a href={phone.href}>{phone.display}</a>
                </span>
              ))}
            </p>
            <p>
              Email:{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </section>

          <section>
            <h2>1. Роль платформы Quokka и ответственность Бизнеса</h2>
            <p>
              1.1. Сервис <strong>Quokka</strong> является технологической платформой (программным
              обеспечением), которая позволяет независимым бизнесам и предпринимателям (далее —
              «Бизнес», выступающий в качестве «Продавца» при продаже товаров либо «Арендодателя /
              Наймодателя» при сдаче имущества в аренду) создавать собственные онлайн-каталоги и
              принимать заказы от клиентов (далее — «Клиент», выступающий в качестве «Покупателя»
              или «Арендатора / Нанимателя»).
            </p>
            <p>
              1.2. На платформе поддерживаются два типа бизнесов:
            </p>
            <ul>
              <li>
                <strong>«Магазин»</strong> — продажа товаров в собственность Покупателя;
              </li>
              <li>
                <strong>«Аренда»</strong> — предоставление товаров, инвентаря, оборудования и иного
                движимого имущества во временное владение и пользование за плату на выбранный период
                (прокат).
              </li>
            </ul>
            <p>
              1.3. Владелец Сервиса (<strong>{OWNER}</strong>) не является собственником, продавцом
              или арендодателем товаров, размещенных на страницах отдельных бизнесов, не
              устанавливает на них цены или тарифы аренды и не принимает денежные средства клиентов
              на свои счета за товары и услуги бизнесов.
            </p>
            <p>
              1.4. Договор розничной купли-продажи либо договор проката (имущественного найма в
              соответствии с главой 27 Гражданского кодекса КР) заключается непосредственно между
              Клиентом и Бизнесом (владельцем соответствующего заведения). Полную ответственность за
              наличие, исправность, качество, безопасность, комплектность, передачу и доставку
              товара, выдачу фискального чека и возврат денежных средств несет Бизнес.
            </p>
          </section>

          <section>
            <h2>2. Порядок оформления заказа и бронирования аренды</h2>
            <p>
              2.1. Клиент выбирает товары в онлайн-каталоге бизнеса, добавляет их в корзину,
              выбирает филиал бизнеса и переходит к оформлению заказа.
            </p>
            <p>
              2.2. При оформлении заказа в бизнесе типа <strong>«Аренда»</strong> Клиент
              дополнительно выбирает для каждой позиции:
            </p>
            <ul>
              <li>
                <strong>период аренды</strong> — дату и время начала (выдачи имущества) и дату и
                время окончания (возврата имущества) по бишкекскому времени (UTC+6);
              </li>
              <li>необходимое количество единиц имущества.</li>
            </ul>
            <p>
              Система автоматически проверяет наличие свободного количества товара в выбранном
              филиале на указанный интервал времени и рассчитывает стоимость аренды пропорционально
              выбранному периоду и установленному Бизнесом тарифному шагу (в минутах, часах или
              сутках).
            </p>
            <p>2.3. При подтверждении заказа Клиент указывает:</p>
            <ul>
              <li>свое имя;</li>
              <li>контактный номер телефона с поддержкой WhatsApp;</li>
              <li>способ получения заказа (самовывоз из филиала или доставка с указанием зоны и адреса);</li>
              <li>комментарий к заказу и промокод (при наличии).</li>
            </ul>
            <p>
              2.4. Для защиты от ошибочных и ложных заявок номер телефона Клиента подтверждается
              одноразовым кодом (OTP), направляемым в мессенджер WhatsApp. После ввода кода заказ
              передается в филиал бизнеса, а Клиенту открывается страница отслеживания статуса и
              оплаты заказа.
            </p>
          </section>

          <section>
            <h2>3. Валюта и способы оплаты</h2>
            <p>
              3.1. Все цены на товары, тарифы аренды (стоимость за единицу времени), услуги доставки
              и тарифы в Сервисе указываются и оплачиваются в национальной валюте Кыргызской
              Республики — <strong>кыргызский сом (KGS)</strong>.
            </p>
            <p>
              3.2. В зависимости от настроек конкретного бизнеса и филиала Клиенту могут быть
              доступны следующие способы оплаты заказа:
            </p>
            <ul>
              <li>
                <strong>Онлайн-оплата по QR-коду (ELQR / O!Деньги / O!Trade и мобильные банки КР)</strong>{' '}
                — безналичная оплата на странице заказа путем сканирования динамического QR-кода или
                перехода в платежное приложение;
              </li>
              <li>
                <strong>Оплата при получении (наличными или переводом/картой на месте)</strong> — при
                самовывозе из филиала бизнеса или при передаче заказа курьером;
              </li>
              <li>
                <strong>Частичная оплата или оплата в рассрочку/долг</strong> — по индивидуальному
                согласованию с Бизнесом с фиксацией остатка суммы на странице заказа.
              </li>
            </ul>
            <p>
              3.3. При онлайн-оплате по QR-коду платеж обрабатывается напрямую через защищенный шлюз
              лицензированного платежного оператора (например, <strong>O!Деньги / O!Trade</strong>) и
              зачисляется непосредственно на расчетный счет или мерчант-кошелек Бизнеса. Сервис
              Quokka не взимает с Клиента дополнительных скрытых комиссий.
            </p>
            <p>
              3.4. После успешного проведения оплаты статус заказа автоматически обновляется на
              «Оплачен», а при подключенной у Бизнеса онлайн-кассе (например, <strong>eKassa</strong>){' '}
              формируется электронный фискальный чек в соответствии с требованиями налогового
              законодательства КР.
            </p>
          </section>

          <section>
            <h2>4. Безопасность платежей</h2>
            <p>
              4.1. Сервис Quokka не запрашивает, не обрабатывает и не хранит данные банковских карт
              клиентов (номер карты, срок действия, CVV/CVC-код, PIN-код или пароли от
              интернет-банкинга).
            </p>
            <p>
              4.2. Все операции по оплате совершаются Клиентом внутри защищенного банковского или
              платежного приложения на его устройстве с использованием стандартов шифрования и
              подтверждения транзакций соответствующего банка или оператора платежной системы.
            </p>
          </section>

          <section>
            <h2>5. Условия доставки и самовывоза</h2>
            <p>
              5.1. <strong>Самовывоз:</strong> Клиент может забрать заказ самостоятельно из
              выбранного филиала бизнеса в соответствии с графиком работы филиала, указанным на
              странице бизнеса. Плата за самовывоз не взимается.
            </p>
            <p>
              5.2. <strong>Доставка:</strong> Если в выбранном филиале подключена доставка, Клиент
              выбирает подходящую зону доставки при оформлении заказа. Стоимость доставки по
              выбранной зоне отображается заранее до подтверждения заказа и включается в общую сумму
              заказа.
            </p>
            <p>
              5.3. Сроки сборки, выдачи и доставки заказа определяются Бизнесом. При изменении
              статуса заказа Клиент может отслеживать актуальный этап выполнения на странице своего
              заказа.
            </p>
          </section>

          <section>
            <h2>6. Особенности аренды (проката) имущества</h2>
            <p>
              6.1. Отношения по заказам в бизнесах типа <strong>«Аренда»</strong> регулируются
              положениями главы 27 Гражданского кодекса Кыргызской Республики («Имущественный наем
              (аренда)», в том числе § 2 «Прокат», ст. 565–572 ГК КР) и Законом КР «О защите прав
              потребителей».
            </p>
            <p>
              6.2. <strong>Передача и проверка исправности (ст. 568 ГК КР):</strong> Арендодатель
              (Бизнес) обязан передать Арендатору (Клиенту) имущество в состоянии, соответствующем
              условиям заказа и назначению имущества, в присутствии Клиента проверить его
              исправность и комплектность, а также ознакомить Клиента с правилами безопасной
              эксплуатации.
            </p>
            <p>
              6.3. <strong>Дополнительные условия выдачи:</strong> При передаче дорогостоящего или
              технически сложного имущества Бизнес по предварительному согласованию с Клиентом
              вправе попросить предъявить документ, удостоверяющий личность, подписать акт
              приема-передачи (договор проката) либо внести обеспечительный залог на условиях,
              определенных Бизнесом в соответствии с законодательством КР.
            </p>
            <p>
              6.4. <strong>Правила пользования и запрет субаренды (ст. 572 ГК КР):</strong> Клиент
              обязан использовать арендованное имущество строго в соответствии с его назначением и
              бережно относиться к нему. Сдача полученного по договору проката имущества в
              субаренду, передача прав и обязанностей другому лицу или предоставление имущества в
              безвозмездное пользование третьим лицам не допускаются.
            </p>
            <p>
              6.5. <strong>Возврат имущества и просрочка (ст. 561 ГК КР):</strong> По окончании
              выбранного периода аренды Клиент обязан своевременно вернуть имущество в филиал
              Бизнеса (либо согласованным способом) в том состоянии, в котором он его получил, с
              учетом нормального износа, и со всеми комплектующими. В случае несвоевременного
              возврата имущества Арендодатель вправе потребовать внесения арендной платы за все
              время просрочки по действующему тарифу.
            </p>
            <p>
              6.6. <strong>Ответственность за повреждение или утрату:</strong> Если возвращенное
              имущество повреждено, разукомплектовано или утрачено по вине Клиента (сверх
              нормального износа), Клиент обязан возместить Бизнесу документально подтвержденные
              убытки (стоимость ремонта, недостающих частей или восстановительную стоимость
              имущества) в соответствии с Гражданским кодексом КР.
            </p>
          </section>

          <section>
            <h2>7. Отмена заказа, обмен, возврат товара и отказ от аренды</h2>
            <p>
              7.1. Права Клиента при покупке и аренде товаров защищаются Законом Кыргызской
              Республики «О защите прав потребителей» и Гражданским кодексом КР.
            </p>
            <p>
              7.2. <strong>Для заказов в бизнесах типа «Магазин» (купля-продажа):</strong>
            </p>
            <ul>
              <li>
                <strong>Отмена заказа до получения:</strong> Покупатель вправе отменить заказ в
                любое время до момента его передачи, связавшись с Продавцом по контактам, указанным
                в заказе или на странице филиала.
              </li>
              <li>
                <strong>Возврат и обмен товара надлежащего качества:</strong> Покупатель вправе
                обменять непродовольственный товар надлежащего качества или вернуть его Продавцу в
                течение <strong>14 (четырнадцати) календарных дней</strong>, не считая дня покупки,
                если товар не был в употреблении, сохранены его товарный вид, потребительские
                свойства, пломбы, ярлыки, а также имеется подтверждение покупки (чек или страница
                заказа). Перечень товаров надлежащего качества, не подлежащих обмену и возврату
                (например, предметы личной гигиены, парфюмерно-косметические товары, белье и др.),
                определяется законодательством КР.
              </li>
              <li>
                <strong>Возврат товара ненадлежащего качества (брак):</strong> При обнаружении
                недостатков или брака товара Покупатель вправе потребовать у Продавца замены товара,
                соразмерного уменьшения цены либо полного возврата уплаченной суммы за счет
                Продавца.
              </li>
            </ul>
            <p>
              7.3. <strong>Для заказов в бизнесах типа «Аренда» (прокат):</strong>
            </p>
            <ul>
              <li>
                <strong>Отмена бронирования до выдачи имущества:</strong> Клиент вправе отменить
                бронирование аренды до начала периода аренды и фактического получения имущества,
                связавшись с Бизнесом, с возвратом внесенной предоплаты.
              </li>
              <li>
                <strong>Обнаружение недостатков арендованного имущества (ст. 569 ГК КР):</strong>{' '}
                При обнаружении в переданном имуществе недостатков, возникших не по вине Клиента и
                полностью или частично препятствующих пользованию им, Арендодатель обязан в
                кратчайший срок безвозмездно устранить недостатки на месте, произвести замену
                другим аналогичным имуществом в надлежащем состоянии либо расторгнуть заказ и
                вернуть уплаченную арендную плату за неиспользованный период.
              </li>
              <li>
                <strong>Досрочный отказ от аренды и возврат имущества (ст. 570 ГК КР):</strong>{' '}
                Арендатор вправе отказаться от договора проката и досрочно вернуть исправное
                имущество Арендодателю. При досрочном возврате имущества перерасчет и возврат
                соответствующей части полученной арендной платы (исчисленной со дня, следующего за
                днем фактического возврата имущества, либо по согласованию сторон за неиспользованный
                период) осуществляются Бизнесом в соответствии со ст. 570 Гражданского кодекса КР.
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Порядок возврата денежных средств</h2>
            <p>
              8.1. Для оформления возврата денежных средств Клиенту необходимо обратиться
              непосредственно в Бизнес (к Продавцу или Арендодателю), в котором был оформлен заказ,
              и указать номер заказа.
            </p>
            <p>
              8.2. При возврате товара, перерасчете аренды или отмене оплаченного заказа Бизнес
              фиксирует возврат в системе (и при наличии подключенной онлайн-кассы формирует
              фискальный чек возврата).
            </p>
            <p>8.3. Способ и сроки возврата денежных средств:</p>
            <ul>
              <li>
                при оплате <strong>наличными</strong> — возврат осуществляется Бизнесом наличными
                при возврате товара (имущества) либо по согласованию сторон;
              </li>
              <li>
                при <strong>безналичной онлайн-оплате (по QR-коду / через платежные сервисы)</strong>{' '}
                — возврат средств производится на тот же банковский счет или электронный кошелек, с
                которого была произведена оплата, либо иным согласованным с Клиентом способом.
              </li>
            </ul>
            <p>
              8.4. Возврат денежных средств осуществляется в течение <strong>3–10 рабочих дней</strong>{' '}
              с момента принятия Бизнесом заявления на возврат (точный срок зачисления зависит от
              регламента банка или платежной системы Клиента).
            </p>
          </section>

          <section>
            <h2>9. Оплата услуг сервиса Quokka владельцами бизнесов</h2>
            <p>
              9.1. В случае подключения владельцем бизнеса платных тарифных планов или
              дополнительных функций платформы Quokka стоимость услуг указывается в кыргызских сомах
              (KGS) и оплачивается в безналичном порядке.
            </p>
            <p>
              9.2. Услуга по предоставлению доступа к программному обеспечению считается оказанной с
              момента активации соответствующего тарифа или периода доступа в личном кабинете
              бизнеса. При ошибочном списании средств владелец бизнеса может обратиться в службу
              поддержки Quokka по адресу{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> в течение 14 календарных дней
              для рассмотрения заявления на возврат.
            </p>
          </section>

          <section>
            <h2>10. Разрешение споров и контакты</h2>
            <p>
              10.1. Все вопросы и претензии, связанные с качеством товара или предмета аренды,
              сроками доставки, состоянием возвращаемого имущества и возвратом оплаты за заказ,
              разрешаются напрямую между Клиентом и Бизнесом (Продавцом / Арендодателем) в
              соответствии с законодательством Кыргызской Республики.
            </p>
            <p>
              10.2. Если у вас возникли технические трудности при работе с сайтом или жалобы на
              недобросовестные действия бизнеса, использующего платформу Quokka, вы можете
              обратиться в службу поддержки Сервиса:
            </p>
            <p>
              <strong>Quokka</strong>
            </p>
            <p>
              Владелец Сервиса: <strong>{OWNER}</strong>
            </p>
            <p>
              Адрес: <strong>{ADDRESS}</strong>
            </p>
            <p>
              Телефон:{' '}
              {PHONES.map((phone, index) => (
                <span key={phone.href}>
                  {index > 0 ? ', ' : null}
                  <a href={phone.href}>{phone.display}</a>
                </span>
              ))}
            </p>
            <p>
              Email:{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
            <p>
              Ознакомиться с правилами обработки персональных данных можно в{' '}
              <Link to="/pages/privacy">Политике конфиденциальности</Link>.
            </p>
          </section>
        </article>
      </main>

      <footer className="ql-footer">
        <div className="ql-footer-inner">
          <strong>Quokka</strong>
          <p>Простой сервис для онлайн-каталога, учёта товаров, продаж и аренды.</p>
          <div className="qp-footer-links">
            <Link className="qp-footer-link" to="/">
              На главную
            </Link>
            <Link className="qp-footer-link" to="/pages/privacy">
              Политика конфиденциальности
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default TermsAndPaymentPage
